import { PublicCartItemCollectionItemResponse } from '../api/response/public-cart-item-collection-item.response';
import { PublicCartItem } from '../models/public-cart-item';
import { PublicCartItemAttribute } from '../models/public-cart-item-attribute';
import { multimediaFromResponse } from '@web/shared/module/multimedia';
import { PublicCartItemStatus } from '../models/public-cart-item-status';

export const publicCartItemFromResponse = (
  item: PublicCartItemCollectionItemResponse,
) => {
  return new PublicCartItem({
    attributes: item.attributes.map(
      (attribute) =>
        new PublicCartItemAttribute({
          id: attribute.id,
          productAttributeLabel: attribute.productAttribute.label,
          productAttributeId: attribute.productAttribute.id,
          value: attribute.value,
        }),
    ),
    id: item.id,
    image: multimediaFromResponse(item.featuredFile),
    subName: item.subName,
    name: item.name,
    price: item.price,
    quantity: item.quantity,
    slug: item.slug,
    status: new PublicCartItemStatus({
      availability: item.status.availability,
      maxQuantityPerOrder: item.status.maxQuantityPerOrder,
      unavailableMessage: item.status.unavailableMessage,
    }),
    type: item.type,
    unitPrice: item.unitPrice,
  });
};
